import React from 'react'
import { MoreHorizontal } from 'lucide-react'
import type { NavItem } from './types'
import { NavEntry } from './NavEntry'

export interface MobileDockProps {
  items: NavItem[]
  hasMission?: boolean
  moreOpen: boolean
  /** "Mehr" hervorheben, wenn die aktuelle Seite nicht im Dock liegt. */
  moreActive?: boolean
  onMore: () => void
  swipeRef?: (el: HTMLElement | null) => void
  moreRef?: React.Ref<HTMLButtonElement>
  /** Kurzbezeichnungen je Pfad (z. B. { '/taktische-karte': 'Karte' }). */
  shortLabels?: Record<string, string>
}

/** Dock am unteren Rand (Handy): 4–5 wichtigste Punkte + "Mehr". Wisch nach oben öffnet das Bottom-Sheet. */
export function MobileDock({ items, hasMission, moreOpen, moreActive, onMore, swipeRef, moreRef, shortLabels }: MobileDockProps) {
  return (
    <nav className="ui-dock" aria-label="Hauptnavigation (Dock)" ref={swipeRef as React.Ref<HTMLElement>}>
      {items.map(it => <NavEntry key={it.path} item={it} variant="dock" hasMission={hasMission} shortLabel={shortLabels?.[it.path]} />)}
      <button
        type="button"
        ref={moreRef}
        className="ui-it ui-it--dock ui-more"
        onClick={onMore}
        aria-label="Mehr"
        aria-haspopup="dialog"
        aria-expanded={moreOpen}
        data-active={moreActive && !moreOpen ? 'true' : undefined}
      >
        <span className="ui-it-ic" aria-hidden="true"><MoreHorizontal /></span>
        <span className="ui-lb">Mehr</span>
      </button>
    </nav>
  )
}
